import { render, staticRenderFns } from "./ViewModelPage.vue?vue&type=template&id=5fbd6421&scoped=true"
import script from "./ViewModelPage.vue?vue&type=script&lang=ts"
export * from "./ViewModelPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd6421",
  null
  
)

export default component.exports